// extracted by mini-css-extract-plugin
module.exports = {"carouselItem":"_37Zwy8gglmw9nRox0Fferr"};